module.exports = __webpack_public_path__ + "static/media/RadiusonesideBlack.6bfb3602.svg";